import { AsciiText } from '../framework/AsciiText';
export class StewartAudioFlxE {
    constructor(socket, log) {
        this.socket = socket;
        this.channels = [];
        this.ampStateCode = 1; // normal
        this.ampTemp = 34.9;
        this.deviceCode = 7; // FLX-E 80 4 CV Dante
        this.mcuTemp = 36.7;
        this.preset = 0;
        this.asyncHandlers = [
            {
                name: 'ping',
                regExp: /^\x1e\x02\x00\x00\x03\x05/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x02]));
                },
            },
            {
                name: 'muteGet',
                regExp: /^\x1e\x03\x00[\s\S]([\x5d\x52])([\s\S])[\s\S]/,
                callback: (match) => {
                    const cmd = match[1].charCodeAt(0);
                    const chanNum = match[2].charCodeAt(0);
                    const type = cmd === 0x5d ? 'input' : 'output';
                    const chan = this.getChannel(type, chanNum);
                    this.socket.send(this.makeCommand([cmd, chanNum, (chan === null || chan === void 0 ? void 0 : chan.mute) ? 1 : 0]));
                },
            },
            {
                name: 'muteSet',
                regExp: /^\x1e\x03\x00[\s\S]([\x50\x51\x5a\x5b])([\s\S])[\s\S]/,
                callback: (match) => {
                    const cmd = match[1].charCodeAt(0);
                    const chanNum = match[2].charCodeAt(0);
                    const type = cmd === 0x5a || cmd === 0x5b ? 'input' : 'output';
                    const mute = cmd === 0x5a || cmd === 0x50;
                    const chan = this.getChannel(type, chanNum);
                    if (chan !== undefined)
                        chan.mute = mute;
                    this.socket.send(this.makeCommand([cmd, chanNum, mute ? 1 : 0]));
                },
            },
            {
                name: 'presetRestore',
                regExp: /^\x1e\x02\x00[\s\S]\x38[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x38, this.preset & 0x0ff, 0]));
                },
            },
            {
                name: 'presetSave',
                regExp: /^\x1e\x03\x00[\s\S]\x39([\s\S])[\s\S]/,
                callback: (match) => {
                    const preset = match[1].charCodeAt(0);
                    const isValidPreset = preset <= 9;
                    if (isValidPreset)
                        this.preset = preset;
                    this.socket.send(this.makeCommand([0x39, isValidPreset ? 1 : 0]));
                },
            },
            {
                name: 'systemStatus',
                regExp: /^\x1e\x02\x00\x00\x05\x07/,
                callback: (match) => {
                    const status = new Array(0x05, // command
                    0x01, // program number
                    ...this.floatToBytes(this.ampTemp), ...this.floatToBytes(this.mcuTemp), this.deviceCode, this.ampStateCode);
                    this.socket.send(this.makeCommand(status));
                },
            },
            {
                name: 'volumeGet',
                regExp: /^\x1e\x03\x00[\s\S]([\x33\x5c])([\s\S])[\s\S]/,
                callback: (match) => {
                    var _a;
                    const cmd = match[1].charCodeAt(0);
                    const chanNum = match[2].charCodeAt(0);
                    const type = cmd === 0x5d ? 'input' : 'output';
                    const chan = this.getChannel(type, chanNum);
                    this.socket.send(this.makeCommand([cmd, chanNum, (_a = chan === null || chan === void 0 ? void 0 : chan.volume) !== null && _a !== void 0 ? _a : 25]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /^\x1e\x04\x00[\s\S]([\x32\x58])([\s\S])([\s\S])[\s\S]/,
                callback: (match) => {
                    const cmd = match[1].charCodeAt(0);
                    const type = cmd === 0x58 ? 'input' : 'output';
                    const chanNum = match[2].charCodeAt(0);
                    const volume = match[3].charCodeAt(0);
                    const chan = this.getChannel(type, chanNum);
                    if (chan !== undefined)
                        chan.volume = volume;
                    this.socket.send(this.makeCommand([cmd, chanNum, volume]));
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    // No response to invalid commands.
                },
            },
        ];
        for (let i = 0; i < 8; i++) {
            this.channels.push({ mute: false, number: i + 1, type: 'input', volume: 25 });
        }
        for (let i = 0; i < 4; i++) {
            this.channels.push({ mute: false, number: i + 1, type: 'output', volume: 25 });
        }
    }
    commandExtractor(buffer) {
        for (let i = 0; i < buffer.length; i++) {
            let checksum = 0;
            if (buffer.charCodeAt(i) === 0x1e) {
                let payloadLen = (buffer.charCodeAt(i + 2) << 8) + buffer.charCodeAt(i + 1);
                if (payloadLen < buffer.length - 3) {
                    for (let j = i + 1; j < i + payloadLen + 3; j++) {
                        checksum += buffer.charCodeAt(j);
                    }
                    checksum = checksum & 0x00ff;
                    if (checksum === buffer.charCodeAt(i + payloadLen + 3)) {
                        const command = buffer.slice(i, i + payloadLen + 4);
                        buffer = buffer.slice(i + payloadLen + 4);
                        return { command, buffer };
                    }
                }
            }
        }
        return undefined;
    }
    floatToBytes(num) {
        const fa = new Float32Array([num]);
        const ba = new Uint8Array(fa.buffer);
        const retArray = new Array(ba[0], ba[1], ba[2], ba[3]);
        return retArray;
    }
    getChannel(type, number) {
        return this.channels.find(c => c.type === type && c.number === number);
    }
    makeCommand(data) {
        const output = [0x1e]; // command header
        const length = data.length + 1; // add one for the message sequence number
        output.push(length & 0x00ff); // low byte of payload length
        output.push((length & 0xff00) >> 8); // high byte of payload length
        output.push(0x00); // message sequence number
        const checksum = data.reduce((sum, current) => sum + current, length);
        output.push(...data, checksum & 0x00ff);
        return AsciiText.decode(output);
    }
}
StewartAudioFlxE.emulatorType = 'socketEmulator';
StewartAudioFlxE.key = '-Ms1XjuvhKuiKlhMWeC_';
